// extracted by mini-css-extract-plugin
export default {"reviwesContainer":"styles_reviwesContainer__fSTts"};